<app-kontable
  id="dt_calendar"
  [title]="'calendarGroupList.listTitle' | translate"
  [columns]="['id', 'description', 'code']"
  [titles]="['ID', 'calendarGroupList.description', 'calendarGroupList.code']"
  [source]="calendarGroups"
  (onAdd)="showAddOrEditDialog(null)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)"
  [(fireNewDataAvailable)]="newDataAvailable"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="true"
>

</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar-group/calendar-group.component.html